export default __webpack_public_path__ + "static/media/screen3.9153542a.webp";